
<template>
  <svg
    :class="isIE11 && 'w600 h500'"
    viewBox="0 0 870 560" 
    preserveAspectRatio="xMidYMid meet"
    id="contendor_componenete_caja_de_circulos_uno"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <linearGradient id="gradient-horizontal" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0" stop-color="#7ed256" />
      <stop offset="1" stop-color="#038452" />
    </linearGradient>

    <template v-for="(val, i) in little_circles_izq">
      <template v-if="val">
        <path :key="i + '_path'" :d="path_tags_i[i]"
          class="line" :class="'stroke_color_green'"/>
        <g :key="i+'_lavel'"
          class="label_little_circle"
          :class="dark_t?'dark':''"
          :transform="'translate('+little_circle_lavel_pos_izq[i].x+','+little_circle_lavel_pos_izq[i].y+')'">
          <text
            text-anchor="end"
            width="290" height="40">
            <template v-if="typeof val['label'] === 'string'">
              <tspan x="0" dy="1em">{{val['label']}}</tspan>
            </template>
            <template v-else>
              <tspan x="0" dy="1em" v-for="(label, il) in val['label']" :key="il">
                {{label}}
              </tspan>
            </template>
          </text>
        </g>
        <circle :key="i + 'lc'"
         v-on:click="val['callback'] || false"
          :cx="little_circle_tags_izq[i].cx" :cy="little_circle_tags_izq[i].cy" :r="little_circle_tags_izq[i].r"
          class="circle little_circle stroke_color_green"
          :class="dark_t?'dark':''">
          <!-- <animate v-if="val['callback']"
            stroke="red"
            attributeName='opacity' 
            from='1' to='0' dur='2s' begin='0s' 
            repeatCount='indefinite'/> -->
        </circle>
        <g :key="i+'_content'"
          :transform="'translate('+little_circle_content_pos_izq[i]['x']+','+little_circle_content_pos_izq[i]['y']+')'">
          <text  
            text-anchor="middle" >
            <template v-if="val['callback']">
              <tspan class="content_little_circle circleCallback " :class="dark_t?'dark':''" v-on:click="val['callback']">{{ltCAncho(val['content'],3)}}</tspan>
            </template>
            <template v-else>
              <tspan  class="content_little_circle" :class="dark_t?'dark':''">{{val['content']}}</tspan>
            </template>
          </text>
        </g>

        <template v-if="val['help']">
          <circle :key="i + 'lc_i_help'"
            :cx="lt_help_izq[i].cx" :cy="lt_help_izq[i].cy" :r="lt_help_izq[i].r"
            class="circle little_circle stroke_color_green"
            :class="dark_t?'dark':''">
          </circle>
          <g :key="i+'_lc_i_help'"
            :transform="'translate('+lt_help_izq[i].cx+','+(lt_help_izq[i].cy + 5)+')'">
            <text text-anchor="middle">
              <tspan v-on:click="val['help']" class="circleCallback lc_help">i</tspan>
            </text>
          </g>
        </template>

      </template>
    </template>

    <template v-for="(val, i) in little_circles_der">
      <template v-if="val">
        <path :key="i + 'd_path'" :d="path_tags_d[i]"
          class="line" :class="'stroke_color_green'" />
        <g :key="i+'d_lavel'"
          class="label_little_circle"
          :class="dark_t?'dark':''"
          :transform="'translate('+little_circle_lavel_pos_der[i].x+','+little_circle_lavel_pos_der[i].y+')'">
          <text
            text-anchor="start"
            width="290" height="40">
            <template v-if="typeof val['label'] === 'string'">
              <tspan x="0" dy="1em">{{val['label']}}</tspan>
            </template>
            <template v-else>
              <tspan x="0" dy="1em" v-for="(label, il) in val['label']" :key="il+'ld'">
                {{label}}
              </tspan>
            </template>
          </text>
        </g>
        <circle :key="i + 'd_lc'"
         v-on:click="val['callback'] || false"
          :cx="little_circle_tags_der[i].cx" :cy="little_circle_tags_der[i].cy" :r="little_circle_tags_der[i].r"
          class="circle little_circle stroke_color_green"
          :class="dark_t?'dark':''">
          <!-- <animate v-if="val['callback']"
            stroke="red"
            attributeName='opacity' 
            from='1' to='0' dur='2s' begin='0s' 
            repeatCount='indefinite'/> -->
        </circle>
        <g :key="i+'d_content'"
          :transform="'translate('+little_circle_content_pos_der[i]['x']+','+little_circle_content_pos_der[i]['y']+')'">
          <text  
            text-anchor="middle" >
            <template v-if="val['callback']">
              <tspan class="content_little_circle circleCallback " :class="dark_t?'dark':''" v-on:click="val['callback']">{{ltCAncho(val['content'],3)}}</tspan>
            </template>
            <template v-else>
              <tspan  class="content_little_circle"  :class="dark_t?'dark':''">{{val['content']}}</tspan>
            </template>
          </text>
        </g>

        <template v-if="val['help']">
          <circle :key="i + 'lc_d_help'"
            :cx="lt_help_der[i].cx" :cy="lt_help_der[i].cy" :r="lt_help_der[i].r"
            class="circle little_circle stroke_color_green"
            :class="dark_t?'dark':''">
          </circle>
          <g :key="i+'_lc_d_help'"
            :transform="'translate('+lt_help_der[i].cx+','+(lt_help_der[i].cy + 5)+')'">
            <text text-anchor="middle">
              <tspan v-on:click="val['help']" class="circleCallback lc_help">i</tspan>
            </text>
          </g>
        </template>

      </template>
    </template>

    <circle cx="420" cy="220" r="150" class="circle big_circle stroke_color_green" :class="dark_t?'dark':''"/>

    <g v-if="big_circle"
      x="110" y="0" class="main_content"
      transform="translate(310,50)">
      <template>
        <text text-anchor="middle" x="110" y="190" class="content1_big_circle" :class="dark_t?'dark':''">
          {{big_circle[0]}}
        </text>
        <text text-anchor="middle" x="110" y="230" class="content2_big_circle" :class="dark_t?'dark':''">
          {{big_circle[1]}}
        </text>
      </template>
    </g>


  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'orange',
    },
    big_circle: {
      type: Array,
      default: () => [
        
        '0000/9999',
        'Total CSP/ total Ri'
       
      ],
    },
    area:{},
    little_circles_izq: {
      type: Array,
      default: () => [
        {
          label: 'bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb',
          content: '000/999',
          callback: false,
        },
        {
          label: 'bbb',
          content: '000/999',
          callback: false,
        },
        {
          label: 'bbb',
          content: '000/999',
          callback: false,
        },
        {
          label: 'bbb',
          content: '000/999',
          callback: false,
        },
       
      ],
    },
    little_circles_der: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isIE11:false,
      path_tags_i: [
        'M205,70L300,130',
        'M170,170L270,190',
        'M170,270L280,250',
        'M195,380L300,310',
        'M290,440L350,340',
      ],
      path_tags_d: [
        'M635,70L530,130',
        'M670,170L480,210',
        'M670,270L480,236',
        'M635,380L530,310',
        'M550,440L480,340',
      ],
      little_circle_tags_izq: [
        { cx: 180, cy: 51, r: 50 },
        { cx: 130, cy: 160, r: 50 },
        { cx: 130, cy: 270, r: 50 },
        { cx: 180, cy: 380, r: 50 },
        { cx: 270, cy: 470, r: 50 },
      ],
      lt_help_izq: [
        { cx: 190, cy: 50, r: 10 },
        { cx: 190, cy: 180, r: 10 },
        { cx: 190, cy: 310, r: 10 },
        { cx: 190, cy: 440, r: 10 },
        { cx: 190, cy: 570, r: 10 },
      ],
      little_circle_lavel_pos_izq: [
        { x: 140, y: 80 },
        { x: 90, y: 190 },
        { x: 90, y: 300 },
        { x: 140, y: 410 },
        { x: 230, y: 520 },
      ],
      little_circle_content_pos_izq: [
        { x: 180, y: 60 },
        { x: 130, y:170 },
        { x: 130, y: 280 },
        { x: 180, y: 390 },
        { x: 270, y: 480 },
      ],

      little_circle_tags_der: [
        { cx: 670, cy: 51, r: 50 },
        { cx: 710, cy: 160, r: 50 },
        { cx: 710, cy: 270, r: 50 },
        { cx: 670, cy: 380, r: 50 },
        { cx: 580, cy: 470, r: 50 },
      ],
      lt_help_der: [
        { cx: 180, cy: 50, r: 50 },
        { cx: 120, cy: 160, r: 50 },
        { cx: 120, cy: 270, r: 50 },
        { cx: 180, cy: 380, r: 50 },
        { cx: 180, cy: 380, r: 50 },
      ],
      little_circle_lavel_pos_der: [
        { x: 720, y: 80 },
        { x: 760, y: 190 },
        { x: 760, y: 300 },
        { x: 720, y: 410 },
        { x: 610, y: 520 },
      ],
      little_circle_content_pos_der: [
        { x: 670, y: 60 },
        { x: 710, y:170 },
        { x: 710, y: 280 },
        { x: 670, y: 390 },
        { x: 580, y: 480 },
      ],
    };
  },
 created(){
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  },
  methods: {
    ltCAncho(val,ancho,i,little_circle_content_pos_izq){
      // por mientras, falta especificar
      let ret = val+'';
      if (ret.length > 3) ret = '1k+'
      return ret;
    }
  },
};
</script>

<style scoped>
.lc_help{
  font-size: 15px;
  stroke: grey;
  fill: grey;
  font-family: initial;
}
.w1000{ width: 1000px !important; }
.h800{ height: 800px !important; }
.circle {
  fill: white;
}
.circle.dark{
  fill: #242424;
}
.big_circle{
  stroke-width: 15px;
}
.little_circle{
  stroke-width: 2px;
}
.label_little_circle{
  text-align: center;
  font-size: 12px;
}
.label_little_circle.dark{
  fill: white;
}
#contendor_componenete_caja_de_circulos_uno{
  color: black;
  width: 100%;
  height: 100%;
}
#gradient-horizontal {
  --color-stop-1: #7ed256;
  --color-stop-2: #4f8834;
}
.stroke_color_grey{ stroke: grey; }
.stroke_color_black{ stroke: black; }
.stroke_color_green{ stroke: url(#gradient-horizontal); }
/* .stroke_color_green2{ stroke: #038452; } */
.line{
  stroke-width: 2px;
  fill: none;
}
.line2{
  stroke-width: 4px;
  fill: none;
}
.content1_big_circle{
  fill: black;
  font-size: 60px;
}
.content1_big_circle.dark{
  fill: white;
}
.content2_big_circle{
  font-size: 16px;
  fill: black;
  font-weight: bold;
}
.content2_big_circle.dark{
  fill: white;
}
.content3_big_circle{
  fill: grey;
  font-weight: bold;
  font-size: 17px;
}
.content4_big_circle{
  fill: black;
  font-size: 120px;
}
.content_little_circle{
  font-size: 25px;
}
.content_little_circle.dark{
  fill:white;
}
.content_little_circle>div{
    width: 100px;
    height: 100px;
    text-align: center;
    word-wrap: break-word;
}
.content_little_circle>div>button{
    font-size: 30px;
    margin-top: 1px;
    border: transparent;
    width: 98px;
    height: 98px;
    border-radius: 50px;
}
.content_little_circle>div>button[disabled]{color: inherit;}
.content_little_circle>div>button:hover:not([disabled]){cursor: pointer;}
.content_little_circle>div>button:focus {outline:0;}

.main_content>table{
    border-collapse: collapse;
    text-align: center;
    width: 100%;
    height: 100%;
}
.main_content>table>tbody>tr:nth-of-type(1){
    height: 60%;
    font-size: 70px;
    vertical-align: bottom;
}
.main_content>table>tbody>tr:nth-of-type(2){
    font-size: 11px;
    color: #f67b2f;
}
.main_content>table>tbody>tr:nth-of-type(3){
    font-size: 15px;
}
.border_color_grey{
    border-right: solid;
    border-color: grey;
}
.border_color_black{
    border-right: solid;
    border-color: black;
}
.border_color_orange{
    border-right: solid;
    border-color: #f67b2f;
}
.main_content>table>tbody>tr>td{
    width: 50%;
}
.circleCallback:hover{
  cursor: pointer;
}
</style>
